<template>
    <div>
      <h3 class="subtitle">{{$t("settings.coreInfo")}}</h3>
      <nav class="level">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading" v-html="$t('settings.all_users')"></p>
            <p class="title">
              <span class="icon">
                <font-awesome-icon :icon="['far', 'user']"></font-awesome-icon>
              </span>
              <span class="status-text">{{ orgUsers.length }}</span>
            </p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading" v-html="$t('settings.open_projects')"></p>
            <p class="title">
              <span class="icon">
                <font-awesome-icon :icon="['fas', 'tasks']"></font-awesome-icon>
              </span>
              <span class="status-text" v-if="activeProjects">{{ activeProjects }}</span>
            </p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading" v-html="$t('settings.last_sync')"></p>
            <p class="title">
              <span class="icon">
                <font-awesome-icon :icon="['far', 'calendar-check']" v-if="orgProjectsTime"></font-awesome-icon>
                <font-awesome-icon :icon="['far', 'calendar-times']" v-else></font-awesome-icon>
              </span>
              <span v-if="orgProjectsTime" class="status-text">{{ orgProjectsTime }}</span>
            </p>
          </div>
        </div>
      </nav>
      <table class="table is-narrow is-fullwidth">
          <tbody>
            <tr>
              <th>
                {{$t("settings.enableSync")}}
              </th>
              <th colspan="2">
                <div class="control">
                  <div class="buttons has-addons">
                    <input type="button" value="Ja" class="button is-small" v-bind:class="{'is-selected': orgSettings.ERPenabled, 'is-success': orgSettings.ERPenabled}" :disabled="!enableFields" @click="handleERPenable(true)">
                    <input type="button" value="Nej" class="button is-small" v-bind:class="{'is-selected': !orgSettings.ERPenabled, 'is-danger': !orgSettings.ERPenabled}" :disabled="!enableFields" @click="handleERPenable(false)">
                  </div>
                </div>
              </th>
            </tr>
              <tr>
                <td>
                  {{$t("settings.setStandardProject")}}
                </td>
                <td colspan="2">
                    <div class="field">
                      <div class="control">
                        <multiselect
                          @input="setStandardProject()"
                          v-model="orgSettings.standardProject" 
                          :options="projectInput"
                          group-values="task"
                          group-label="no"
                          :placeholder="$t('input.choose')"
                          track-by="task_no"
                          label="description"
                          :select-label="$t('input.choose')"
                          :deselect-label="$t('input.remove')"
                          :disabled="!enableFields">
                          <span slot="noResult">{{$t('input.noProjectFound')}}</span>
                        </multiselect>
                      </div>
                      <p class="help">{{$t('settings.SPtext')}}</p>
                    </div>
                </td>
            </tr>
            <tr>
              <td>
                  {{$t("settings.setStandardReg")}}
                </td>
              <td colspan="2">
                    <div class="field">
                      <div class="control">
                        <multiselect
                          @input="setStandardReg()"
                          v-model="orgSettings.standardRegistration" 
                          track-by="type"
                          label="text"
                          :options="$t('settings.regInput')"
                          :placeholder="$t('input.choose')"
                          :select-label="$t('input.choose')"
                          :deselect-label="$t('input.remove')"
                          :disabled="!enableFields">
                          <span slot="noResult">{{$t('input.noProjectFound')}}</span>
                        </multiselect>
                      </div>
                      <p class="help">{{$t('settings.SRtext')}}</p>
                    </div>
                </td>
              </tr>
            <tr></tr>
          </tbody>
          <tbody v-if="!orgSettings.ERPenabled">
            <tr>
              <td>
                {{$t('settings.projects')}}
              </td>
              <td>
                  <div class="field has-addons">
                    <div class="control">
                       <input class="input is-small" type="text" v-model="projectName" :placeholder="$t('input.typeName')" :disabled="!enableFields">
                        <p class="help">{{$t("settings.createProjectsText")}}</p>
                    </div>
                    <div class="control">
                      <input type="button" class="button is-small is-primary" :value="$t('input.createProject')" @click="addCustomProject()" :disabled="!enableFields">                      
                    </div>
                  </div>
              </td>
              <td>
                  <InputCustomProject :org-settings="orgSettings" :enable-fields="enableFields" />                
              </td>
            </tr>
            <tr>
              <td>
                {{$t("registrations.absence")}}
              </td>
              <td>
                  <div class="field has-addons">
                    <div class="control">
                       <input class="input is-small" type="text" v-model="absenceName" placeholder="Angiv navn" :disabled="!enableFields">
                        <p class="help">{{$t("settings.createAbsence")}}</p>
                    </div>
                    <div class="control">
                      <input type="button" class="button is-small is-primary" :value="$t('input.createAbsence')" @click="addCustomAbsence()" :disabled="!enableFields">                      
                    </div>
                  </div>
              </td>
              <td>
                  <ul>
                    <li v-for="(absence, key) in orgSettings.customAbsence" v-bind:key="key">
                      <strong>{{ absence.name }}</strong>
                    </li>
                  </ul>          
              </td>
            </tr>
          </tbody>
          <tbody v-if="orgSettings.ERPenabled">
             <tr>
              <td>
                {{$t("settings.ERPurl")}}
              </td>
              <td>
                <p class="control">
                    <input class="input is-primary" type="text" v-model="orgSettings.OdataUrl" :disabled="!enableFields">
                    <span class="help">Format: [url]:[odata port]/[ERP sti]/Company('[firma]')/[webtjeneste]</span>
                </p>
              </td>
            </tr>
             <tr>
              <td>
                {{$t("settings.ERPuser")}}
              </td>
              <td>
                <p class="control">
                    <input class="input is-primary" type="text" v-model="orgSettings.ERPuser" :disabled="!enableFields">
                </p>
              </td>
            </tr>
            <tr>
              <td>
                {{$t("settings.ERPpassword")}}
              </td>
              <td>
                <p class="control">
                    <input class="input is-primary" type="password" v-model="orgSettings.ERPpass" :disabled="!enableFields">
                </p>
              </td>
            </tr>
            <!-- <tr>
              <td>
                Fraværsregistrering
              </td>
              <td>
                <div class="columns">
                  <div class="column is-2">
                    <p class="control">
                        <input type="checkbox" v-model="orgSettings.ERPabsence" :disabled="!enableFields">
                    </p>
                  </div>
                  <div class="column">
                    <InputProperties 
                      :is-disabled="!enableFields"
                      input-type="table"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                E-mailnotifikationer
              </td>
              <td>
                <p class="control">
                    <input type="checkbox" v-model="orgSettings.emailNotifications" :disabled="!enableFields">
                </p>
              </td>
            </tr>
            <tr>
              <td>
                Antal dage uden registreringer<br> før notifikation
              </td>
              <td class="wide-column">
                <p class="control">
                    <input class="input is-primary" type="number" v-model.number="orgSettings.emailNoDays" :disabled="!enableFields">
                </p>
              </td>
            </tr> -->
          </tbody>
          <tbody>
            <tr>
              <td>
                <p class="buttons">
                  <a @click="enabledLockedFields()" v-if="!enableFields" class="button is-small is-info">
                    <span class="icon">
                      <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                    </span>
                    {{$t('input.edit')}} 
                  </a>
                  <a @click="updateSettings()" v-if="enableFields" class="button is-small is-primary">
                    <span class="icon">
                      <font-awesome-icon icon="check"></font-awesome-icon>
                    </span>
                    {{$t('input.save')}} 
                  </a>
                  <a @click="enableFields = false" v-if="enableFields" class="button is-small is-danger">
                      <span class="icon">
                        <font-awesome-icon icon="times"></font-awesome-icon>
                    </span>
                    {{$t('input.cancel')}} 
                  </a>
                </p>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <h3 class="subtitle" id="users">
          {{$t('settings.users')}} 
          <input type="text" class="input is-small" :placeholder="$t('input.searchName')" style="max-width:300px" v-model="userSearch">
        </h3>
         <table class="table is-narrow is-fullwidth">
            <thead>
              <tr>
                <th>{{$t('settings.name')}}</th>
                <th>{{$t('settings.email')}}</th>
                <th>{{$t('settings.res')}}</th>
                <th>{{$t('settings.active')}}</th>
                <th>{{$t('settings.avail')}}</th>
                <th>{{$t('settings.approver')}}</th>
                <th>{{$t('settings.role')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in filteredOrgUsers" :key="user['.key']">
                <td>
                  <span v-if="user && user.userCanEdit && user.userCanEdit.name">{{ user.userCanEdit.name }}</span>
                </td>
                <td>
                  <span v-if="user && user.userCanEdit && user.userCanEdit.email">{{ user.userCanEdit.email }}</span>
                </td>
                <td>
                  <span v-if="user && user.userCanEdit && user.userCanEdit.email">{{ findResource(user.userCanEdit.email, 'res_no') }}</span>
                </td>
                <td>
                    <div class="buttons has-addons">
                      <input type="button" value="Ja" class="button is-small" v-bind:class="{'is-selected': user.adminCanEdit.active, 'is-success': user.adminCanEdit.active}" :disabled="user.adminCanEdit.active" @click="handleActiveState(true, user['.key'])">
                      <input type="button" value="Nej" class="button is-small" v-bind:class="{'is-selected': !user.adminCanEdit.active, 'is-danger': !user.adminCanEdit.active}" :disabled="!user.adminCanEdit.active" @click="handleActiveState(false, user['.key'])">
                    </div>
                  <div class="field">
                    <div class="control">
                        <Datepicker
                            v-model="user.adminCanEdit.activeDate"
                            :language="da" 
                            class="input is-small"
                            input-class="date-picker"
                            format="dd/MM/yy"
                            :monday-first="true"
                            :disabled="!user.adminCanEdit.active"
                        ></Datepicker>
                      <p class="help">{{$t("settings.chooseStartDateText")}}</p>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                       <input class="input is-small" type="number" v-model.number="user.adminCanEdit.vacationStartBalance" placeholder="0" :disabled="!user.adminCanEdit.active">
                      <p class="help">{{$t("settings.vacationStartDateNeg")}}</p>
                    </div>
                  </div>
                  <div class="field has-addons">
                    <div class="control">
                       <input class="input is-small" type="number" v-model.number="user.adminCanEdit.startBalance" placeholder="0" :disabled="!user.adminCanEdit.active">
                      <p class="help">{{$t("settings.chooseStartDateNeg")}}</p>
                    </div>
                    <div class="control">
                      <input class="button is-small is-success" @click="updateActiveDate(user.adminCanEdit.activeDate, user['.key'], user.adminCanEdit.startBalance, user.adminCanEdit.vacationStartBalance)" :value="$t('input.save')" type="button" :disabled="!user.adminCanEdit.active">
                    </div>
                  </div>
                </td>
                <td style="min-width: 90px;">
                    <div class="buttons has-addons">
                      <input type="button" value="ja" class="button is-small" v-bind:class="{'is-selected': user.adminCanEdit.availabilityCommitment, 'is-success': user.adminCanEdit.availabilityCommitment}" :disabled="!user.adminCanEdit.active" @click="handleAvailabilityCommitment(true, user['.key'])">
                      <input type="button" value="Nej" class="button is-small" v-bind:class="{'is-selected': !user.adminCanEdit.availabilityCommitment, 'is-danger': !user.adminCanEdit.availabilityCommitment}" :disabled="!user.adminCanEdit.active" @click="handleAvailabilityCommitment(false, user['.key'])">
                      <p class="help">{{$t("settings.hoursSub")}}</p>
                    </div>
                </td>
                <td>
                  <div class="field">
                    <InputApproverFor :uid="user['.key']" />
                    <p class="help">{{$t("settings.chooseApp")}}</p>
                  </div>
                </td>
                <td>
                  {{ user.adminCanEdit.role }}
                </td>
              </tr>
            </tbody>
        </table>
         <!-- <h3 class="subtitle" id="resources">
          {{ $t("settings.resources") }}
         </h3>
          <table class="table is-narrow is-fullwidth">
            <thead>
              <tr>
                <th>{{$t("settings.resTable.name")}}</th>
                <th>{{$t("settings.resTable.totalSalary")}}</th>
                <th>{{$t("settings.resTable.costPrice")}}</th>
                <th>{{$t("settings.resTable.salesPrice")}}</th>
                <th>{{$t("settings.resTable.history")}}</th>
              </tr>
            </thead>
            <tbody>
               <tr v-for="user in orgUsers" :key="user['.key']">
                <td>{{ user.userCanEdit.name }}</td>
                <td>
                  <InputUserSalary :user="user"/>
                </td>
                <td>
                  <a class="tag" :title="$t('settings.resTable.hoursRegistered')">{{ returnMonthlyHours(user) }}</a>
                </td>
                <td>
                </td>
                <td>
                  <PriceHistory :user="user" />           
                </td>
              </tr>
            </tbody>
          </table> -->
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import {en, da} from 'vuejs-datepicker/dist/locale'

import PriceHistory from '@/components/settings/PriceHistory.vue'
import InputProperties from '@/components/inputs/InputProperties.vue'
import InputCustomProject from '@/components/inputs/InputCustomProject.vue'
import InputApproverFor from '@/components/inputs/InputApproverFor.vue'
import InputUserSalary from '@/components/inputs/InputUserSalary.vue'
import calendar from '../../utils/calendar'

export default {
  name: 'SettingsOrg',
    components: {
      InputProperties,
      InputCustomProject,
      Datepicker,
      Multiselect,
      InputApproverFor,
      InputUserSalary,
      PriceHistory
  },
  watch: {
    '$route' (to, from) {
        if(to.params.nav2) {
          this.$scrollTo('#' + to.params.nav2)
        }
    }
  },
  data: function() {
      return {
          currentSalary: [],
          da: da,
          projectName: '',
          absenceName: '',
          orgSettings: false,
          enableFields: false,
          orgProjectsTime: false,
          userSearch: null,
          error: false,
      }
    },
    firebase: function() { 
      const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
      const userid = JSON.parse(localStorage.getItem('profile')).user_id;
      return {
          allProjectLinesFavorites: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/JobTaskLines'),
          },
          allRegistrations: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrations/'),
            asObject: false,
            readyCallback() {
            }
          },
          orgSettings: {
              source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
              asObject: true,
          },
          orgUsers: {
              source: firebase.database().ref('/organisations/' + tenantid + '/users'),
              asObject: false,
          },
          orgResources: {
              source: firebase.database().ref('/organisations/' + tenantid + '/ResourceList').orderByChild('type').equalTo('Person'),
              asObject: false,
          },
          orgProjectLines: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobTaskLines'),
          },
          orgProjects: {
              source: firebase.database().ref('/organisations/' + tenantid + '/JobList').orderByChild('status').equalTo('Open'),
              asObject: false,
              readyCallback() {
                if(this.orgProjects && this.orgProjects[0]) {
                  const timestampLastEdited = this.orgProjects[0].timestamp;
                  this.orgProjectsTime = moment(timestampLastEdited).format("DD/MM/YYYY");
                }
              }
          },
      }
    },
    beforeCreate() {
      this.calendar = calendar
    },
    computed: {
      filteredOrgUsers() {
        if(this.userSearch) {
          return this.orgUsers.filter(((user) =>{
            return user.userCanEdit.name.match(this.userSearch)
          }))
        } else {
            return this.orgUsers;
          }
      },
      activeProjects() {
          if(!this.orgSettings.ERPenabled) {
            return this.groupCustomProjects.length
          } else if (this.orgProjects) {
            return this.orgProjects.length
          }
      },
      projectInput() {
          if(!this.orgSettings.ERPenabled) {
            return this.groupCustomProjects;
          } else {
            return this.groupProjectLines
          }
      },
      groupCustomProjects() {
        if(!this.orgSettings.ERPenabled) {
          const self = this;
          let groupedProjectsArray = []
          groupedProjectsArray = _.map(this.orgSettings.customProjects, function(project,pkey) {
            return {
              key: pkey,
              no: project.name,
              task: _.without(_.map(self.orgSettings.customProjectLines, function(line, plkey) {
                if(pkey === line.project) {
                  return {
                    no: pkey,
                    task_no: plkey,
                    description: line.name
                  }
                } else {
                  return null;
                }
              }), null)
            }
          })
          return groupedProjectsArray
        } else {
          return null;
        }
      },
      groupProjectLines: function() {
          // merge all project tasks with favorites if project & task is fav
          function mergeByJob(objValue, srcValue, key, object, source, stack){
            if (object.Job_No == source.Job_No && object.Job_Task_No == source.Job_Task_No) {
              // console.log("key: ", key)
              // console.log("object: ", object.Job_No)
              _.merge(objValue, {favorite: true});
            }
          }
          _.mergeWith(this.orgProjectLines, this.allProjectLinesFavorites, mergeByJob);
          // set variable for description search
          var desc = this.orgProjectLines;
          // set variable for project description substitution
          var projects = this.orgProjects;
          var result = _.chain(this.orgProjectLines).groupBy("no").map(function(v, i) {
            return {
              // find project description
              no: _.get(_.find(projects, {'no': i}), 'description') + ' (' + i + ')', //i,
              task:
                _.chain(v).groupBy("task_no").map(function(v2, i2) {
                  // if favorite add star to description
                  var fav = '';
                  if (_.get(_.find(v2, 'favorite'), 'favorite') == true) {
                    fav = '★ '
                  }
                  return {
                    no: i,
                    task_no: i2,
                    description: fav + _.get(_.find(desc, {'no': i, 'task_no': i2}), 'description') + ' (' + i2 + ')',
                  }
              }).value()
            }
          }).value();
          // reverse in order to get favorites first TODO fix sort order
          return result;
      }
    },
    methods: {
      returnMonthlyHours(user) {
        if(this.allRegistrations && user) {
          const userRegs = _.filter(this.allRegistrations, {'.key': user['.key']})
          const monthlyRegs = _.map(userRegs, function(o) {
            return _.filter(o, function(reg) {
              if(moment(reg.date).isSame(moment().subtract(1, 'months'), 'month')) {
                return o
              }
            })
          })
          return _.sumBy(_.flatMap(monthlyRegs), 'time')
        }
      },
      setStandardReg() {
        if(this.orgSettings.standardRegistration) {
          this.$firebaseRefs.orgSettings.update({'standardRegistration': this.orgSettings.standardRegistration});
        } else {
          this.$firebaseRefs.orgSettings.update({'standardRegistration': false});
        }
      },
      setStandardProject() {
        if(this.orgSettings.standardProject.no && this.orgSettings.standardProject.task_no) {
          this.$firebaseRefs.orgSettings.update({'useStandardProject': true});
          this.orgSettings.standardProject.timestamp = moment().format();
          this.orgSettings.standardProject.projectCombined = this.orgSettings.standardProject.no + '-' + this.orgSettings.standardProject.task_no;
          this.orgSettings.standardProject.isCustomProject = !this.orgSettings.ERPenabled
          this.$firebaseRefs.orgSettings.child('/standardProject').update(this.orgSettings.standardProject);
        } else {
          this.$firebaseRefs.orgSettings.update({'useStandardProject': false});
        }
      },
      addCustomAbsence() {
        const absence = {
          name: this.absenceName,
          timestamp: moment().format(),
          uid: JSON.parse(localStorage.getItem('profile')).user_id
        }
        this.$firebaseRefs.orgSettings.child('/customAbsence').push(absence);
      },
      addCustomProject(){
        const project = {
          name: this.projectName,
          timestamp: moment().format(),
          uid: JSON.parse(localStorage.getItem('profile')).user_id
        }
        this.$firebaseRefs.orgSettings.child('/customProjects').push(project);
      }, 
      handleERPenable(isActive) {
        this.$firebaseRefs.orgSettings.update({'ERPenabled': isActive});
      },
      handleAvailabilityCommitment(isActive, uid) {
        this.$firebaseRefs.orgUsers.child(uid + '/adminCanEdit/').update({'availabilityCommitment': isActive});
      },
      updateActiveDate(date, uid, balance, vacBalance) {
        try {
          this.$firebaseRefs.orgUsers.child(uid + '/adminCanEdit/').update({
            'activeDate': moment(date).format('YYYY-MM-DD'),
            'startBalance': balance || 0,
            'vacationStartBalance': vacBalance || 0 
          });
        } catch(error) {
          this.error = error
        } finally {
          if(!this.error) {
            this.$snotify.success(this.$i18n.t('messages.infoSaved'), {
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true
            });
          } else {
            this.$snotify.warning(this.$i18n.t('messages.errorMessage'), {
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true
            });  
          }
        }
      },
      handleActiveState(isActive, uid) {
        this.$firebaseRefs.orgUsers.child(uid + '/adminCanEdit/').update({'active': isActive});
      },
      findResource(email, type) {
        if(email) {
          const rest = _.find(this.orgResources, {search_name: email.toUpperCase()}) || null; 
          return _.get(rest, type) || null;
        }
      },
      enabledLockedFields: function() {
        this.enableFields = true;
      },
      updateSettings: function() {
        if (this.enableFields == true) {
          const now = moment().format();
          const updates = {
            'ERPenabled': this.orgSettings.ERPenabled || false,
            'emailNotifications': this.orgSettings.emailNotifications || false, 
            'emailNoDays': this.orgSettings.emailNoDays  || false, 
            'companyNameInERP': this.orgSettings.companyNameInERP  || false, 
            'urlToERP': this.orgSettings.urlToERP  || false, 
            'odataPort': this.orgSettings.odataPort  || false, 
            'timestampLastEdited': now
          };
          this.$firebaseRefs.orgSettings.update(updates);
          this.enableFields = false;
        } else {
          console.log("Kan ikke opdatere")
        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .icon {
        margin-right: 0.375em!important;
    }
    .wide-column {
      width: 70%;
    }
    .status-text {
      line-height: 2em;
      padding-bottom: 0.4em;
      padding-left:0.2em;
      vertical-align: middle;
    }
    .date-picker {
      font-size: 12px;
      /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  }

</style>
